import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { theme } from '../../theme/theme'
import { darken } from 'polished'
import Spacer from '../Spacer'
import Arrow from './arrow'
import PropTypes from 'prop-types'
import { screenSizes } from '../../lib/constants'

const StyledButton = styled.button`
    background: transparent;
    border-color: transparent;

    a {
        position: relative;
        border: 2px solid ${(props) => props.borderColor};
        border-radius: 6px;
        padding: ${(props) => (props.size === 'default' ? '0.8rem 5rem 0.8rem 2rem' : '0.8rem 5rem 0.8rem 2rem')};
        display: inline-flex;
        align-items: center;
        background: transparent;
        transition: all 0.5s ease-out;

        &:hover {
            border-color: ${(props) => darken(0.15, props.borderColor)};

            img {
                right: -1rem;
            }
        }

        img {
            position: absolute;
            right: 1rem;
            transition: all 0.5s ease-out;
        }
    }

    @media (max-width: ${screenSizes.lg}px) {
        padding: ${(props) => (props.size === 'default' ? '0.8rem 3rem 0.8rem 2rem' : '0.8rem 3rem 0.8rem 2rem')};
    }
`

const Text = styled.div`
    color: ${(props) => props.textColor};
    font-weight: ${(props) => props.textWeight};
    font-size: ${(props) => props.textSize};
    text-transform: ${(props) => props.textStyle};
`

const Button = (props) => {
    return (
        <StyledButton {...props}>
            <Link to={props.link}>
                <Text {...props}>{props.children}</Text>
                <Spacer left="1" right="1" md={{ left: '0.2', right: '1' }} />
                <Arrow color={props.arrowColor} size={props.arrowSize} />
            </Link>
        </StyledButton>
    )
}

Button.propTypes = {
    link: PropTypes.string,
    borderColor: PropTypes.string,
    accentColor: PropTypes.string,
    arrowColor: PropTypes.string,
    arrowSize: PropTypes.string,
    size: PropTypes.string,
    textColor: PropTypes.string,
    textStyle: PropTypes.string,
    textSize: PropTypes.string,
    textWeight: PropTypes.string,
}

Button.defaultProps = {
    link: '/',
    borderColor: `${theme.lightBlue}`,
    accentColor: `${theme.blue}`,
    arrowColor: 'white',
    arrowSize: '40',
    size: 'default',
    textColor: '#fff',
    textStyle: 'uppercase',
    textSize: '0.8em',
    textWeight: 'bold',
}

export default Button
